import { i18n } from '@lingui/core';
import AriaAnnounceProgress from './AriaAnnounceProgress.js';
import type { Props } from './types.js';
import { activateLang } from '../locales/loadTranslations.js';
import { messages as fi } from '../locales/fi/messages_fi.js';
import { messages as en } from '../locales/en/messages_en.js';
import { messages as nb } from '../locales/nb/messages_nb.js';
import { messages as da } from '../locales/da/messages_da.js';
import { messages as sv } from '../locales/sv/messages_sv.js';

const getAriaAnnouncer = ({ step, numberOfSteps }: { step: number; numberOfSteps: number }) =>
    i18n._({
        id: 'div.StepAnnouncer.progress',
        comment:
            'Screen reader only text to let the user know approximatly how much they have left',
        message: 'You have approximately {0}% left',
        values: {
            0: 100 - Math.round((step / numberOfSteps) * 10) * 10,
        },
    });

const ProgressBar = ({ step, numberOfSteps, size = 'medium' }: Props) => {
    const heigth = size === 'medium' ? 'h-4' : 'h-6';
    activateLang({ fi, en, nb, da, sv });

    return (
        <div className={`relative ${heigth} s-bg-primary-subtle -mt-16`}>
            <AriaAnnounceProgress ariaAnnounceText={getAriaAnnouncer({ step, numberOfSteps })} />
            <div
                className={`absolute top-0 left-0 ${heigth} s-bg-primary transition-all duration-1000 ease-out`}
                style={{ width: `${(step / numberOfSteps) * 100}%` }}
            ></div>
        </div>
    );
};

export default ProgressBar;
